import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/dashboards.svg'


const _withScopeId = n => (_pushScopeId("data-v-436eab26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-not-found" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

import { translate } from "@/lib/i18n-helpers";

export default /*#__PURE__*/_defineComponent({
  __name: 'PageNotFound',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(translate)("not_found_page")), 1),
    _hoisted_3
  ]))
}
}

})